import { render, staticRenderFns } from "./PurchaseInvoiceBillingForm.vue?vue&type=template&id=4cc6077a&scoped=true&"
import script from "./PurchaseInvoiceBillingForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoiceBillingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc6077a",
  null
  
)

export default component.exports